// import Cookies from "universal-cookie";

type Affiliate = {
  referrer: string;
  applicationPath: string;
  // callback?: (a:Affiliate) => void
};

const affiliates = new Map<string, Affiliate>();

affiliates.set("/virginia-spouses", {
  referrer: "Virginia DVS",
  applicationPath: "protege-spouse"
});

affiliates.set("/virginia", {
  referrer: "Virginia DVS",
  applicationPath: "protege"
});

affiliates.set("/linkedin", {
  referrer: "LinkedIn",
  applicationPath: "mentor/ACPUSA"
  // callback: (a) => {
  //   const cookies = new Cookies();
  //   cookies.set("referrer", "linkedin", { path: "/", maxAge: 60 * 60 * 24 * 14 });
  // }
});

export default affiliates;
